import { useState } from 'react';
import { Box, Button, FormLabel, Grid, InputLabel } from '@mui/material';
import { Field, Form, Formik, useFormik } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from "yup";
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import { setIsActiveSpinner } from '../../Redux/GeneralSlice';
import StripeUtils from './StripeUtils';

let validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Required"),
    // email: Yup.string().required("Required")
});


function UsBankAccountForm({ getClientSecret, userId, getPaymentMethods=null }) {
    const elements = useElements();
    const stripe = useStripe();
    const dispatch = useDispatch();
    const [clientSecret, setClientSecret] = useState(null);
    const [showConfirmForm, setShowConfirmForm] = useState(false);
    const [USBankAccount, setUSBankAccount] = useState(null);

    const bankAccountValues = {
        fullName: '',
        // email: '',
        authorization: false
    };

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const saveNewBankAccount = async (client_secret_stripe, event) => {
        const { fullName } = event;
        // Calling this method will open the instant verification dialog.
        stripe.collectBankAccountForSetup({
            clientSecret: client_secret_stripe,
            params: {
                payment_method_type: 'us_bank_account',
                payment_method_data: {
                    billing_details: {
                        name: fullName,
                        // email: email
                    },
                },
            },
            expand: ['payment_method'],
        })
            .then(({ setupIntent, error }) => {
                if (error) {
                    // PaymentMethod collection failed for some reason.
                    alert('error in collect Bank Account: ' + error.message);
                    console.error(error.message);
                } else if (setupIntent.status === 'requires_payment_method') {
                    console.log("canceled");
                    // Customer canceled the hosted verification modal. Present them with other
                    // payment method type options.
                } else if (setupIntent.status === 'requires_confirmation') {
                    setUSBankAccount(setupIntent.payment_method['us_bank_account']);
                    setShowConfirmForm(true);
                }
            });
    };

    const handleSubmit = async (event) => {
        try {
            // event.preventDefault();
            dispatch(setIsActiveSpinner(true));
            let client_secret_stripe = await getClientSecret('us_bank_account');
            setClientSecret(client_secret_stripe);
            if (!stripe || !elements) {
                return;
            }
            if (!client_secret_stripe) {
                return;
            }
            await saveNewBankAccount(client_secret_stripe, event);
            dispatch(setIsActiveSpinner(false));
        } catch {
            dispatch(setIsActiveSpinner(false));
        }
    };

    const acceptingFuturePayments = async (paymentMethodID) => {
        const res = await StripeUtils.acceptingFuturePayments(paymentMethodID, userId);
        if (res.success) {
            return true;
        } else {
            alert("error in accepting future payments: " + res.error);
            return false;
        }
    };

    const handleSubmitConfirmForm = async (e) => {
        e.preventDefault();
        stripe.confirmUsBankAccountSetup(clientSecret)
            .then(({ setupIntent, error }) => {
                if (error) {
                    alert('error: ' + error.message)
                    console.error(error.message);
                    // The payment failed for some reason.
                } else if (setupIntent.status === "requires_payment_method") {
                    alert('Confirmation failed. Attempt again with a different payment method.')
                    // Confirmation failed. Attempt again with a different payment method.
                } else if (setupIntent.status === "succeeded") {
                    endAndSetToDefault(setupIntent);
                } else if (setupIntent.next_action?.type === "verify_with_microdeposits") {
                    alert("error verify_with_microdeposits");
                }
            });
    };

    const endAndSetToDefault = async(setupIntent) => {
        const res = await acceptingFuturePayments(setupIntent.payment_method);
        if (res) {
            const is_success = await StripeUtils.updatePaymentMethodToDefault(
                dispatch, setupIntent.payment_method, userId);
            if (is_success) {
            //   getPaymentMethods();
              alert("Successfully added payment method !!")
            } else {
                alert("Successfully added payment method but not set to default !!")
            }
        }
    };

    return (
        <Box>
            {!showConfirmForm && <Formik
                initialValues={bankAccountValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ dirty, isValid, values, handleBlur, setFieldValue }) => {
                    return (
                        <Form style={{ width: '350px' }}>
                            <FormLabel>US bank account</FormLabel>
                            <Grid sx={{ width: "100%" }}>
                                <Grid item sx={{ minHeight: "85px" }}>
                                    <InputLabel className='f-14'>Account Holder Name</InputLabel>
                                    <Field
                                        size="small"
                                        name="fullName"
                                        value={values.fullName || ""}
                                        component={TextField}
                                    />
                                </Grid>
                                {/* <Grid item sx={{ minHeight: "85px" }}>
                                    <InputLabel className='f-14'>Email Address</InputLabel>
                                    <Field
                                        name="email"
                                        size="small"
                                        value={values.email || ""}
                                        component={TextField}
                                    />
                                </Grid> */}
                                <Grid sx={{ width: "350px", mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        // || !values.authorization
                                        disabled={!isValid}
                                        className="blue-btn"
                                        sx={{ float: "right" }}
                                    >
                                        Continue
                                    </Button>
                                </Grid>

                            </Grid>
                        </Form>
                    )
                }}
            </Formik>}
            {showConfirmForm && <form style={{ width: '450px' }} onSubmit={handleSubmitConfirmForm}>
                <Box sx={{ width: "250px", mb: 3, mt: 3 }}>
                    <p>Bank Name: {USBankAccount.bank_name}</p>
                    <p>Routing Number: {USBankAccount.routing_number}</p>
                    <p>Account Number: ****{USBankAccount.last4}</p>
                </Box>
                <label>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    I authorize the ACH debit payment
                </label>
                <br />
                <Grid sx={{ justifyContent: 'center', display: 'flex' }}>
                    <Button
                        type="submit"
                        variant="outlined"
                        disabled={!isChecked}
                        className="blue-btn"
                        sx={{ marginTop: "15px" }}
                    >
                        Submit
                    </Button>
                </Grid>
            </form>}
        </Box>

    )
}

export default UsBankAccountForm;